export default "__VITE_ASSET__62b8c29c__"